"use client";

import config from "@/app.config";
import routes from "@/app.route";
import SparkleEffect from "@/components/sparkle-effect";
import categories from "@/constants/categories.constant";
import Image from "next/image";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

export default function Categories() {
  return (
    <section className="py-4">
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        spaceBetween={12}
        slidesPerView="auto"
        loop
      >
        {categories.map((category, index) => (
          <SwiperSlide className="max-w-[180px] md:pb-2" key={index}>
            <SparkleEffect>
              <Link
                className="block bg-white px-2 py-4 shadow-sm hover:shadow-md duration-500"
                href={routes.category.url.replace(":slug", category.handle)}
              >
                <Image
                  src={`${config.app.apiBaseUrl}/${category.image}`}
                  alt={category.title}
                  width={64}
                  height={64}
                  className="mx-auto h-16 object-contain"
                />
                <div className="mt-3 text-center font-semibold text-sm">
                  {category.title}
                </div>
              </Link>
            </SparkleEffect>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
